module.exports = __webpack_public_path__ + "img/monitor-recorder.7ffe8322.svg";